import { atom } from "jotai";

import { BookingWizardDataAtom } from "../../stores";

export const updateRoundTransportationIdAtom = atom(
  null,
  (get, set, playerId: string, transportationId: string) => {
    const bookingWizardData = get(BookingWizardDataAtom);
    if (!bookingWizardData || bookingWizardData.type !== "GolfBooking") {
      //@TODO: this is an error
      return;
    }

    const newRounds = bookingWizardData.rounds.map((r) => {
      if (r.player.id === playerId) {
        return {
          ...r,
          transportationType: {
            id: transportationId,
          },
        };
      }
      return r;
    });

    set(BookingWizardDataAtom, {
      ...bookingWizardData,
      rounds: newRounds,
    });
  }
);
